import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateBulkFieldCropPractice } from "services";

import { invalidateQueriesAfterFieldsBulkUpdate } from "utils";

import {
  GET_FARM_RESILIENCE_SCORE,
  GET_FIELD_PRACTICE_FILTER_OPTIONS,
  GET_INCENTIVES_POTENTIAL_PAYOUTS,
  GET_VERIFICATION_EDITING_REQUESTS,
  UPDATE_BULK_FIELD_CROP_PRACTICE,
} from "consts";

export const useBulkAddUpdateFieldCropPractice = ({ fieldIds, farmId }: { fieldIds: string[]; farmId?: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_FIELD_CROP_PRACTICE],
    mutationFn: updateBulkFieldCropPractice,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
      queryClient.invalidateQueries({ queryKey: [GET_INCENTIVES_POTENTIAL_PAYOUTS] });
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_PRACTICE_FILTER_OPTIONS] });
      queryClient.invalidateQueries({ queryKey: [GET_VERIFICATION_EDITING_REQUESTS, farmId] });
      if (farmId) {
        queryClient.invalidateQueries({ queryKey: [GET_FARM_RESILIENCE_SCORE, farmId] });
      }
    },
  });
};
